import { useEffect } from "react";

import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import ManageAdminUsers from "./components/ManageAdminUsers.component";
import { appInsights } from "../../config/appInsights";
import { RootState } from "../../redux/store";

const ManageRolesAndUsers = () => {
  const history = useHistory();

  const isAuthenticated = useSelector(
    (state: RootState) => state?.authReducer.isAuthenticated,
  );

  useEffect(() => {
    appInsights.trackPageView({
      name: "User Management - (ManageRolesAndUsers.jsx)",
      isLoggedIn: true,
    });
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      history.push("/login");
    }
  }, [history, isAuthenticated]);

  //JSX Template
  return (
    <div className="ManageRoles datatable-wrapper">
      <div className="table-view">
        <ManageAdminUsers />;
      </div>
    </div>
  );
};

export default ManageRolesAndUsers;
